import Firebase from '@constants/firebase';
export var buildFingerprint = function (_a) {
    var message = _a.message, errorType = _a.errorType;
    var raw = [message, errorType].filter(Boolean).join('|');
    var hash = 0;
    for (var i = 0; i < raw.length; i++) {
        hash = (hash << 5) - hash + raw.charCodeAt(i);
        hash |= 0;
    }
    return "".concat(Firebase.FINGERPRINT_PREFIX).concat(Math.abs(hash).toString(36));
};
